module.exports = __webpack_public_path__ + "media/1x1/ss-e3933b44.svg";